import React, { Component } from 'react';
import './horizonralSlide.css';
import img1 from './img1.jpg';
import img2 from './img2.jpg';
import img3 from './img3.jpg';
import img4 from './img4.jpg';
import img5 from './img5.jpg';
import img6 from './img6.jpg';
import img7 from './img7.jpg';

class HorizontalSlide extends Component {
    constructor () {
        super();
        this.state = { style: {} };
    }
    componentDidMount() {
        let ypos = 0;
        setInterval(() => {
            if (ypos===7) {
                ypos=0;
                this.setState({
                    style: {
                        transition: `all 0s ease`,
                        transform: `translateY(-${ypos*900}px)`
                    }
                });
                setTimeout(() => {
                    ypos = 1;
                    this.setState({
                        style: {
                            transition: `all 1s ease`,
                            transform: `translateY(-${ypos*900}px)`
                        }
                    });
                }, 100)
            } else {
                ypos += 1;
                this.setState({
                    style: {
                        transition: `all 1s ease`,
                        transform: `translateY(-${ypos*900}px)`
                    }
                });
            }
        }, 5000);
    }
    render() {
        return (
            <div className="hSlide">
                <div className="hSlideCont" style={this.state.style}>
                    <img src={img1}/>
                    <img src={img2}/>
                    <img src={img3}/>
                    <img src={img4}/>
                    <img src={img5}/>
                    <img src={img6}/>
                    <img src={img7}/>
                    <img src={img1}/>
                </div>
            </div>
        )
    }
}

export default HorizontalSlide;


// WEBPACK FOOTER //
// ./src/About/horizontalSlide.js